import {pageInfo, rePush} from './../api';
const orderReceiptLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    rePushObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, item.dealStatus == '处理失败'] }));
    },
    RE_PUSH(state, data) {
      state.rePushObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async rePush({commit}, obj) {
      let resp = await rePush(obj);
      commit('RE_PUSH', resp);
    },
  }
}
export default orderReceiptLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderReceiptLog/store/orderReceiptLog.store.js